import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from '../common/axios';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../components/SFooter';
import Header from '../components/Header';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
  Stack
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";



const backendUrl = process.env.REACT_APP_BACKEND_URL;

const PaymentResult = () => {
//  const { status, invoiceId } = useParams("success",1);
  const [invoice, setInvoice] = useState();
  const location = useLocation();

  const { t } = useTranslation();
    const navigate = useNavigate();
  // Get data passed from navigation state
  const { status, invoiceId } = location.state || {};
  
  useEffect(() => {
  //  if (status === "success" && invoiceId) {
     fetchInvoice();
  //  }
  }, [status, invoiceId]);
  
   async function fetchInvoice(){ 
     const res = await axiosInstance
        .get(`${backendUrl}/api/invoices/${invoiceId}`)
       console.log("res ", res); 
      // const data =  res.json(;
     console.log("res ", res.data); 
      setInvoice(res.data);
  };

  
  const handleBack = () => {

    navigate(`/`);
  }
  const handleDownload = () => {
    if (!invoiceId) return;
    axiosInstance
      .get(`${backendUrl}/api/invoices/${invoiceId}/download`, { responseType: "blob" })
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `invoice_${invoiceId}.pdf`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => console.error(err));
  };

  if (status === "failure") {
    return <h2 className="text-red-600">❌ {t("payment_failed" , "Payment Failed. Please try again.")}</h2>;
  }

  return (
    <>
            <Header />
      
      
   <Box
  sx={{
    minHeight: "100vh",          // Full screen height
    display: "flex",
    justifyContent: "center",    // Horizontal center
    alignItems: "center",        // Vertical center
    backgroundColor: "#f5f5f5",
  }}
>
  <Card
    sx={{
      width: 420,
      p: 3,
      boxShadow: 6,
      borderRadius: 3,
    }}
  >
    <CardContent>
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <CheckCircleIcon sx={{ fontSize: 50, color: "green" }} />
        <Typography variant="h5" color="green" fontWeight="bold">
          {t("payment_successful", "Payment Successful")}!
        </Typography>
      </Box>

      {invoice && (
        <>
          <Typography variant="body1">
            <strong>{t("invoice_number", "Invoice Number")}:</strong>{" "}
            {invoice.invoiceNumber}
          </Typography>

          <Typography variant="body1">
            <strong>{t("date", "Date")}:</strong>{" "}
            {new Date(invoice.invoiceDate).toLocaleString()}
          </Typography>

          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>{t("total", "Total")}:</strong> {invoice.totalAmount}
          </Typography>
<Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
  <Stack direction="row" spacing={2}>
    <Button
      variant="contained"
      color="secondary"
      onClick={handleBack}
    >
      {t("home", "Home")}
    </Button>

    <Button
      variant="contained"
      color="primary"
      onClick={handleDownload}
    >
      {t("download_invoice", "Download Invoice")}
    </Button>
  </Stack>
</Box>
        </>
      )}
    </CardContent>
  </Card>
    </Box>
       <Footer />
    </>
  );
};

export default PaymentResult;
